import React, { useEffect } from 'react'
import './App.css'
import { Route, Switch } from 'react-router-dom'
import Index from './pages/index'
import Meeting from './pages/meeting'
import PaymentResponse from './pages/payment-response'
import { BrowserRouterHook } from './utils/use-router'
import ClientAppointment from './pages/client-appointment'
function App () {

  return (
    <BrowserRouterHook>
      <Switch>
        <Route path = "/book-appointment" component={ClientAppointment}></Route>
        <Route path="/payment" component={PaymentResponse}></Route>
        <Route exact path="/meeting/:name" component={Meeting}></Route>
        <Route path="/:id" component={Index}></Route>
      </Switch>
    </BrowserRouterHook>
  )
}

export default App
